import "./ExcalidrawLogo.scss";

const LogoIcon = () => (

  <svg className="ExcalidrawLogo" version="1.0" xmlns="http://www.w3.org/2000/svg"
   viewBox="0 0 1790.000000 1344.000000"
   preserveAspectRatio="xMidYMid meet">

  <g transform="translate(0.000000,1344.000000) scale(0.100000,-0.100000)"
  fill="#797979" stroke="none">
  <path d="M4700 13433 c-308 -20 -496 -44 -720 -89 -1071 -215 -2089 -825
  -2807 -1684 -705 -843 -1105 -1840 -1163 -2900 -5 -101 -9 -1196 -10 -2577 l0
  -2403 895 0 895 0 0 2338 c0 2331 4 2604 35 2832 117 836 553 1573 1230 2080
  1074 804 2558 822 3655 45 262 -186 518 -437 712 -698 l58 -79 0 1209 0 1208
  -33 19 c-646 375 -1236 578 -1927 665 -267 34 -617 48 -820 34z"/>
  <path d="M7877 10708 c-3 -2744 1 -2552 -58 -2848 -77 -386 -240 -780 -458
  -1106 -140 -210 -211 -295 -405 -489 -483 -482 -1063 -763 -1732 -841 -190
  -22 -572 -15 -764 15 -241 37 -469 99 -688 187 -577 232 -1084 639 -1434 1153
  -39 57 -88 134 -110 170 l-38 66 0 -1285 0 -1285 88 -56 c617 -398 1322 -648
  2083 -740 157 -19 236 -23 539 -23 361 -1 450 5 730 45 1198 173 2319 808
  3050 1729 520 655 876 1540 959 2390 7 63 14 129 18 145 3 17 8 626 12 1355
  l6 1324 1605 -2196 1605 -2197 20 24 c11 13 733 1001 1605 2194 872 1193 1588
  2170 1593 2170 4 1 7 -1536 7 -3414 l0 -3415 895 0 895 0 0 4720 0 4720 -1028
  0 -1029 0 -1474 -2029 c-811 -1117 -1476 -2030 -1479 -2030 -3 -1 -669 912
  -1480 2029 l-1475 2029 -1027 1 -1028 0 -3 -2512z"/>
  <path d="M9620 6083 c-377 -728 -941 -1379 -1617 -1867 l-123 -88 0 -174 0
  -174 895 0 895 0 0 1195 c0 657 -1 1195 -2 1195 -2 0 -23 -39 -48 -87z"/>
  </g>
  </svg>

);

const LogoText = () => (
  <svg
    viewBox="0 0 450 55"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    className="ExcalidrawLogo-text"
  >
    <path
    />
    <path
    />
    <path
    />
    <path
    />
  </svg>
);

type LogoSize = "xs" | "small" | "normal" | "large" | "custom";

interface LogoProps {
  size?: LogoSize;
  withText?: boolean;
  style?: React.CSSProperties;
  /**
   * If true, the logo will not be wrapped in a Link component.
   * The link prop will be ignored as well.
   * It will merely be a plain div.
   */
  isNotLink?: boolean;
}

export const ExcalidrawLogo = ({
  style,
  size = "small",
  withText,
}: LogoProps) => {
  return (
    <div className={`ExcalidrawLogo is-${size}`} style={style}>
      <LogoIcon />
      {withText && <LogoText />}
    </div>
  );
};
